import React,{useState} from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './Components/mshc2026/Header';
import Login from './Components/mshc2026/Login';
import Lobby from './Components/mshc2026/Lobby';
import SpeakerList from './Components/mshc2026/speakers/SpeakerList';
import SpeakerDetails from './Components/mshc2026/speakers/SpeakerDetails';
import SponsorList from './Components/mshc2026/sponsors/Sponsors';
import SponsorDetails from './Components/mshc2026/sponsors/SponsorDetails';
import AttendeesList from './Components/mshc2026/attendee/Attendees';
import AttendeeDetails from './Components/mshc2026/attendee/AttendeeDetails';
import ExhibitHall from './Components/mshc2026/attendee/ExhibitHall';
import ExhibitorDetails from './Components/mshc2026/attendee/ExhibitorDetails';
import ConferenceSchedule from './Components/mshc2026/conference/getSession';
import Maps from './Components/mshc2026/Maps/Maps';
import MapDetail from './Components/mshc2026/Maps/MapDetail';
import UserProfile from './Components/mshc2026/UserProfile';
import LoginSplash from './Components/mshc2026/LoginSplash';
import ExhibitorProfile from './Components/mshc2026/Exhibitor/profile';
import SpeakerProfile from './Components/mshc2026/speakers/SpeakerProfile';
import ChatPage from "./TmChat/mshc2026/chat/ChatPage";
import ChatNotification from "./TmChat/mshc2026/chat/ChatNotification";

import PrivateRoute from './PrivateRoute';


const Mshc2026 = () => {
    const [exhibitorToken,setExhibitorToken] = useState(localStorage.getItem('exhibitorToken') || null);

    return (
        <Router>
            <Header exhibitorToken={exhibitorToken} />
            {exhibitorToken?<ChatNotification />:''}
            <Switch>
                {/* <Route path="/" exact component={Login} /> */}
                <Route path="/mshc2026/login/:id" exact render={(props) => <Login setExhibitorToken={setExhibitorToken} {...props}/>} />
                <PrivateRoute path="/mshc2026/loginSplash" exact component={LoginSplash} />
                <PrivateRoute path="/mshc2026/conference" exact component={ConferenceSchedule} />
                <PrivateRoute path="/mshc2026/lobby" exact component={Lobby} />
                <PrivateRoute path="/mshc2026/speakers" exact component={SpeakerList} />
                <PrivateRoute path="/mshc2026/speakers/:id" exact component={SpeakerDetails} />
                <PrivateRoute path="/mshc2026/sponsors" exact component={SponsorList} />
                <PrivateRoute path="/mshc2026/sponsor/:id" exact component={SponsorDetails} />
                <PrivateRoute path="/mshc2026/attendees" exact component={AttendeesList} />
                <PrivateRoute path="/mshc2026/attendee/exhibitHall" exact component={ExhibitHall} />
                <PrivateRoute path="/mshc2026/attendee/exhibitor/:exhibitorId/:title" exact component={ExhibitorDetails} />
                {/* <PrivateRoute path="/mdapa2024/attendee/:emailId/:userId" exact component={AttendeeDetails} /> */}
                <PrivateRoute path="/mshc2026/attendee/:emailId/" exact component={AttendeeDetails} />
                <PrivateRoute path="/mshc2026/maps" exact component={Maps} />
                <PrivateRoute path="/mshc2026/maps/details" exact component={MapDetail} />
                <PrivateRoute path="/mshc2026/user/profile" exact component={UserProfile} />
                <PrivateRoute path="/mshc2026/exhibitor/profile" exact component={ExhibitorProfile} />
                <PrivateRoute path="/mshc2026/speaker/profile" exact component={SpeakerProfile} />
                <PrivateRoute path="/mshc2026/chat" exact component={ChatPage} />
                

            </Switch>
        </Router>
    )
}
export default Mshc2026;